<template>
  <div style="position: relative; padding-top: 70px;">
    <slide-navbar-component />
    <navbar-component />
    <carousel-layout />
  </div>
</template>

<script>
import SlideNavbarComponent from '@/components/SlideNavbar.vue'
import NavbarComponent from '@/components/Navbar.vue'
import CarouselLayout from '@/layouts/home/Carousel.vue'

export default {
  name: 'HomeView',
  data() {
    return {
      //variables
    }
  },
  components: {
    SlideNavbarComponent,
    NavbarComponent,
    CarouselLayout,
  },
}
</script>
